import { GTM } from '@common/config'

import { getNonce } from '../csp/nonce'

import loadSnippet from './loadSnippet'

type DataLayerName = `dataLayer${string}`

class DrmaxGtm {
  w: Window
  layerName: DataLayerName
  enabled: boolean

  constructor(w: Window, d: Document, s: 'script', layerName: DataLayerName, gtmId: string) {
    this.w = w
    this.layerName = layerName
    this.enabled = !!gtmId
    this.w[this.layerName] = this.w[this.layerName] || []
    const nonce = getNonce()
    // exposed for GTM Custom HTML tags as Data Layer Variable {{cspNonce}}: <script nonce="{{cspNonce}}">
    this.gtmPushEvent({ singlePageApp: true, cspNonce: nonce })

    if (this.enabled) {
      loadSnippet(w, d, s, layerName, gtmId, nonce)
    }
  }

  gtmPushEvent(gtmEvent: Record<string, unknown>) {
    if (GTM.log) {
      console[GTM.log || 'debug']('GTM event', gtmEvent)
    }

    if (this.enabled) {
      try {
        this.w[this.layerName]?.push(gtmEvent)
      } catch (err) {
        throw new Error(`GTM event push failed: ${String(err)}`)
      }
    }
  }

  update() {
    this.gtmPushEvent({
      event: 'virtualPageview',
    })
  }
}

export const gtm = new DrmaxGtm(window, document, 'script', 'dataLayerDRMAX', GTM.id)
